import { Injectable } from '@angular/core';
import { StoreData } from '@shared/module/common/model/store-data';
import { UI } from '@shared/models/ui';
import { LemsarApiClient } from '@lemsar/api/client';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { Observable } from 'rxjs/Observable';
import { Collection } from '@lemsar/common/domains/interface/collection';
import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { Message } from '@lemsar/message/domains/model/message';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    29/11/2020
 */
@Injectable()
export class MessageService {
    private _ui: StoreData<UI>;

    public constructor(private api: LemsarApiClient, private authStore: AuthStore) {
        this._ui = new StoreData<UI>(new UI());
    }

    public get ui$(): Observable<UI> {
        return this._ui.stream$;
    }

    public get ui(): UI {
        return this._ui.value;
    }

    public fetchMessagesByInstitution(institution: string, params?: any): Observable<Collection<Message>> {
        const queryParams = !params
            ? { page: 1, limit: 20 }
            : { page: params.page || 1, limit: params.limit || 20, group: params.group || [] };

        return this.api
            .get<Collection<Message>>(`institutions/${institution}/messages`, queryParams)
            .pipe(ResponseTransformer.toCollection(Message));
    }

    public fetchLatestUnreadMessagesByUser(user: string): Observable<Array<Message>> {
        return this.api
            .get<Array<Message>>(`users/${user}/latest-unread-messages`)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(Message));
    }

    public createMessage(institution: string, body: any = {}): Observable<Message> {
        return this.api
            .post<Message>(`institutions/${institution}/messages`, body)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Message));
    }

    public deleteMessage(message: string): Observable<Message> {
        return this.api
            .delete<Message | any>(`messages/${message}`)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toSingleClass(Message));
    }

    public readMessage(institution: string): Observable<Array<Message>> {
        return this.api
            .patch<Array<Message>>(`institutions/${institution}/messages/read`, {})
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(Message));
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/message/domains/services/message.service.ts